import React, { useState, useEffect } from "react";
import "../createAnnouncement/styles/index.less";
import { Breadcrumb, Layout, Row, Typography } from "antd";
import { useParams } from "react-router-dom";
import CreateBanner from "./components/createbanner";
import UploadBanner from "./components/uploadbanner";
import { useNavigate } from "react-router-dom";
import { get_all_announcement } from "../../services/announcement";
import { useTranslation } from "react-i18next";

const { Content } = Layout;
const { Title } = Typography;

type Props = {};

const CreateAnnouncement = (props: Props) => {
  const params = useParams();
  const { type } = useParams<{ type: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [AnnouncementType, setAnnouncementTypeStr] = useState<string | null>(
    null
  );

  // check data match true => create or upload page
  useEffect(() => {
    const getCheckAnnounce = async () => {
      try {
        const res = await get_all_announcement();
        if (res.result && Array.isArray(res.result)) {
          const matchedAnnounce = res.result.find(
            (item: { announcement_id: string | undefined }) =>
              item.announcement_id === params.task_id
          );
          if (matchedAnnounce) {
            const typeStr =
              matchedAnnounce.announcement_type === 1 ? "create" : "upload";
            setAnnouncementTypeStr(typeStr);
          }
        }
      } catch (error) {
        console.error("❌ Error fetching announcements:", error);
      }
    };
    getCheckAnnounce();
  }, [params.task_id]);

  return (
    <Layout>
      <Content className="layout-announcement">
        <div>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {params.action == "new"
                        ? t("Add Announcement")
                        : t("Edit Announcement")}
                    </span>
                  ),
                },
              ]}
            />
          </Row>
          <hr />
        </div>

        {/* check type create */}
        {type === "upload" && (
          <Content>
            <UploadBanner></UploadBanner>
          </Content>
        )}

        {type === "create" && (
          <Content>
            <CreateBanner></CreateBanner>
          </Content>
        )}

        {/* edit */}
        {AnnouncementType === "upload" && (
          <Content>
            <UploadBanner></UploadBanner>
          </Content>
        )}

        {AnnouncementType === "create" && (
          <Content>
            <CreateBanner></CreateBanner>
          </Content>
        )}
      </Content>
    </Layout>
  );
};

export default CreateAnnouncement;
